import { LandscapeType } from '@/api/rest/resources/types/fact';
import { Logger } from '@/lib/logs/logger';
import { resolveThemeColor } from '@/utils/resolveThemeColor';

export const getLandscapeTypeColor = (type: LandscapeType): string => {
  switch (type) {
    case LandscapeType.tree_cover:
      return resolveThemeColor('landscape-type-tree-cover-main');
    case LandscapeType.built_up:
      return resolveThemeColor('landscape-type-built-up-main');
    case LandscapeType.cropland:
      return resolveThemeColor('landscape-type-cropland-main');
    case LandscapeType.grassland:
      return resolveThemeColor('landscape-type-grassland-main');
    case LandscapeType.bareground:
      return resolveThemeColor('landscape-type-bareground-main');
    case LandscapeType.herbaceous_wetland:
      return resolveThemeColor('landscape-type-herbaceous-wetland-main');
    case LandscapeType.shrubland:
      return resolveThemeColor('landscape-type-shrubland-main');
    case LandscapeType.permanent_water_bodies:
      return resolveThemeColor('landscape-type-permanent-water-bodies-main');
    case LandscapeType.snow_and_ice:
      return resolveThemeColor('landscape-type-snow-and-ice-main');
    default:
      Logger.error(`No color defined for landscape type "${type}"`);
      return resolveThemeColor('black-100');
  }
};
